import { TXN_REG_PREF_FF } from './data';
import { PrefType } from './type';

export const excludedForViewOnly = [
  TXN_REG_PREF_FF.prefEditDownloaded,
  TXN_REG_PREF_FF.prefDeleteDownloaded,
  TXN_REG_PREF_FF.prefAutoSaveEditedTxns,
  TXN_REG_PREF_FF.prefNewTxnEntry,
];

export const getAllPrefsData = (prefsData: PrefType[], hasWriteAccess: boolean) => prefsData.filter((pref) => {
  if (hasWriteAccess) {
    return true;
  }

  return !excludedForViewOnly.includes(pref.fflag);
});

export const getAdvancedPrefs = (prefsData: PrefType[], featureFlags: Record<string, any>) => (
  prefsData.filter((pref) => (
    pref.fflag && (featureFlags.get(pref.fflag) === 'advanced' || !featureFlags.get(pref.fflag))
  ))
);

export const getVisiblePrefsData = (prefsData: PrefType[], featureFlags: Record<string, any>) => (
  prefsData.filter((pref) => (
    !pref.fflag || featureFlags.get(pref.fflag) === true || featureFlags.get(pref.fflag) === 'show'
  ))
);
